import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import HeroSection from './components/HeroSection';
import TopCasinos from './components/TopCasinos';
import CategoriesNav from './components/CategoriesNav';
import HowWeRate from './components/HowWeRate';
import GamesSection from './components/GamesSection';
import GameOfMonth from './components/GameOfMonth';
import WhyChooseUs from './components/WhyChooseUs';
import ExpertReviews from './components/ExpertReviews';
import TrustIndicators from './components/TrustIndicators';
import NewsSection from './components/NewsSection';
import SafetySection from './components/SafetySection';
import Footer from './components/Footer';

export default function HomePage() {
  const location = useLocation();

  useEffect(() => {
    if (location.pathname !== '/top-casinos') return;
    const section = document.getElementById('top-casinos');
    if (!section) return;

    requestAnimationFrame(() => {
      section.scrollIntoView({ behavior: 'smooth', block: 'start' });
    });
  }, [location.pathname]);

  return (
    <div className="min-h-screen bg-white">
      <HeroSection />
      <TopCasinos />
      <CategoriesNav />
      <HowWeRate />
      <GamesSection />
      <GameOfMonth />
      <WhyChooseUs />
      <ExpertReviews />
      <TrustIndicators />
      <NewsSection />
      <SafetySection />
      <Footer />
    </div>
  );
}